












































import Vue from 'vue'
import { mapGetters } from 'vuex'
import { CreditLineProvisionService } from '@/api/services/credit-line-provision'

export default Vue.extend({
  data() {
    return {
      loading: false,
      states: {
        pending: { label: 'En attente', color: 'yellow-600', bg: 'yellow-200' },
        successeed: { label: 'Succès', color: 'green-100', bg: 'green-300' },
        failed: { label: 'Échec', color: 'red-100', bg: 'red-300' }
      },
      columns: [
        {
          label: 'N° transaction',
          field: '_iteration'
        },
        {
          label: 'Ligne de crédit',
          field: 'creditLine.name'
        },
        {
          label: 'Date/Heure',
          field: 'createdAt'
        },
        {
          label: 'Montant',
          field: 'amount'
        },
        {
          label: 'Solde disponible',
          field: '_balance'
        },
        {
          label: 'Opérateur Mobile',
          field: 'otm',
          align: 'center',
          width: 'w-64'
        },
        {
          label: 'Statut',
          field: 'state',
          align: 'center'
        }
      ],
      rows: [],
      total: 0,
      pagination: {
        page: 1,
        perPage: 10
      }
    }
  },

  computed: {
    ...mapGetters('auth', ['user'])
  },

  async created() {
    this.loading = true
    await this.fetchData()
    this.loading = false
    // CreditLineProvision.api()
    //   .fetchForCurrentOrganization({
    //     'state!': 'canceled',
    //     include: ['creditLine', 'transaction']
    //   })
    //   .then((response: any) => {
    //     this.loading = false
    //   })
    //   .catch((error: Error) => {
    //     console.error(error)
    //     this.loading = false
    //   })
  },

  methods: {
    async fetchData(this: any) {
      const response = await CreditLineProvisionService.findAll(
        this.$route.params.productId,
        this.pagination,
        this.user.organizationId
      )
      this.rows = response.result
      this.total = response.count
    },

    getProvisionBalance(item: any) {
      const balance =
        item.otm === 'mtn'
          ? item.creditLine.mtnAmount
          : item.creditLine.moovAmount

      return balance > 0 ? balance : 0
    },

    onPrev() {
      if (this.pagination.page > 1) {
        this.pagination.page--
        this.fetchData()
      }
    },

    onNext() {
      if (
        this.total &&
        this.pagination.page * this.pagination.perPage < this.total
      ) {
        this.pagination.page++
        this.fetchData()
      }
    }
  }
})
